import { TextField } from "@mui/material";
import { useField } from 'formik';
import PTFormInput from "./PTFormInput";
import PTTextInput from "./PTTextInput";

export const PTDateInput = (props) => {
  
  return (
    <PTTextInput {...props} type="date" />
  );
};